// Import dependencies
import React, {Component} from 'react';
import * as THREE from 'three';
import { EventBusSingleton } from 'light-event-bus'

import threeEntryPoint from "./threeEntryPoint";
import '../../screens/Services.css'



const coordinates = [
    [ new THREE.Vector3(80, 0, 0), new THREE.Vector3(120, 0, 0) ],
    [ new THREE.Vector3(0, 0, -80), new THREE.Vector3(0, 0, -120) ],
    [ new THREE.Vector3(-80, 0, 0), new THREE.Vector3(-120, 0, 0) ],
    [ new THREE.Vector3(0, 0, 80), new THREE.Vector3(0, 0, 120) ]
];

export default class ThreeJSComponent extends Component {
    updateSlide(slide) {
        EventBusSingleton.publish('slide-changed', coordinates[slide][1]);
        window.sceneManager.onSlideChange(coordinates[slide][0])
    }

    componentDidMount() {
        // Run WebGL animation
        threeEntryPoint(this.threeRootElement);
    }

    // Listen to new props
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.slide !== this.props.slide) {
            this.updateSlide(nextProps.slide);
        }
    }

    render() {
        return (
            <div className='services__webgl-container' ref={element => this.threeRootElement = element} />
        );
    }
}
